<template>
  <v-card>
    <v-card-title>マスターデータの設定</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <!-- {{ rules }} -->
          <!-- {{ values }} -->
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="ラベル名"
                v-model="returnData.label"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          {{ returnData }}
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="参照ページID"
                v-model="returnData.init"
                required
                :rules="[varidation.numonly, varidation.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="ページ内検索キーformID"
                v-model="rules[0]"
                :rules="[varidation.required]"
                hint="数値じゃなければ固定値検索"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="検索対象のformID"
                v-model="rules[1]"
                :rules="[varidation.numonly, varidation.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                v-model="rules[2]"
                label="マスタデータ形式で保存"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" v-if="rules[2] == 'true'">
              <v-text-field
                v-model="rules[3]"
                label="formID"
                persistent-hint
                hint="同じページにマスタ表示サブページがある場合入力"
              ></v-text-field>
            </v-col>
            <v-col cols="4" v-if="rules[2] == 'true'">
              <v-text-field
                v-model="rules[4]"
                label="マスタページ内対象formID"
                persistent-hint
                hint="同じページにマスタ表示サブページがある場合入力"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    //個別値
    init: String,
    rule: String,
    value: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        //個別値
        init: this.init,
        rule: this.rule,
        value: this.value,
      },
      rules: [],
      values: [],
      //バリデーション
      valid: true,
      varidation: {
        def: (value) => {
          return /^[\x]*$/.test(value) || "全角スペースが入っています";
        },
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      headers: [],
    };
  },
  mounted() {
    if (typeof this.rule != "undefined" && this.rule != "") {
      this.rules = this.rule.split(",");
    }
  },
  methods: {
    submit() {
      //バリデーション
      if (this.$refs.form.validate()) {
        this.returnData.rule = this.rules.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
  },
};
</script>
